import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Flickity from "react-flickity-component"
import { btnPrimary, btnSmall } from "../../ds/button.module.css"
import { BlackArrowRight, File, QuoteIconWithColor } from "../../ds/Shapes"
import useWindowDimensions from "../../utils/useWindowDimensions"

let target

export const TESTIMONIALS: Array<{
  logo: React.ReactNode
  message: string
  profile: React.ReactNode
  name: string
  designation: string
  company: string
  color: string
  lightColor: string
  lightestColor: string
  url: string
  stats: string
}> = [
  {
    logo: (
      <StaticImage
        src="../../images/client-logos/41.png"
        height={60}
        alt="G2"
        placeholder="blurred"
      />
    ),
    message: `"I was very impressed by Premagic's event marketing posters. Before our event, we saw many of these posters being posted on Linkedin and I am confident that it played a pivotal role in increasing our registration numbers for the event. The visibility and engagement created a difference in our promotional efforts and brand presence. It's very easy to use and implement.”`,
    profile: (
      <StaticImage
        src="../../images/case-study/g2-live/kevin.png"
        class="rounded-full"
        width={60}
        height={60}
        alt="Kevin Fernandes, New Business Acquisition Manager"
        placeholder="blurred"
      />
    ),
    name: "Kevin Fernandes",
    designation: "New Business Acquisition Manager",
    company: "G2 APAC",
    color: "#1F0F61",
    lightColor: "#DBD2FD",
    lightestColor: "#F5F2FF",
    url: "/case-study/g2-live/",
    stats: `<span class='font-bold text-6xl'>1500</span><br /> <br />Photos delivered to attendees in real-time at the Mercedes Benz EQR-SUV showcase.`,
  },
  {
    logo: (
      <StaticImage
        src="../../images/client-logos/34.png"
        height={30}
        alt="Gitex"
        placeholder="blurred"
      />
    ),
    message: `"Photo distribution is definitely a key component in ensuring that all event attendees have a memorable experience at the show, which in turn encourages them to get more involved. Premagic made this seamless and efficient, ensuring attendees received their photos instantly and shared them widely! ”`,
    profile: (
      <StaticImage
        src="../../images/case-study/gitex-global/shreya.png"
        class="rounded-full"
        width={60}
        height={60}
        alt="Shreya Shyamsunder, Marketing Executive"
        placeholder="blurred"
      />
    ),
    name: "Shreya Shyamsunder",
    designation: "Marketing Executive",
    company: "Dubai World Trade Center",
    color: "#f15757",
    lightColor: "#FFE5E5",
    lightestColor: "#FFE5E5",
    url: "/case-study/gitex-global/",
    stats: `<span class='font-bold text-6xl'>130k</span><br /> <br />Impressions were generated at the Asia Berlin Summit.`,
  },
  {
    logo: (
      <StaticImage
        src="../../images/client-logos/30.png"
        height={50}
        alt="Step-conference"
        placeholder="blurred"
      />
    ),
    message: `"To my fellow marketers, Premagic can really boost your organic presence and engagement during and after the event. I’d highly recommend it for any event business.”`,
    profile: (
      <StaticImage
        src="../../images/case-study/stepconference/avatar.png"
        class="rounded-full"
        width={60}
        height={60}
        alt="Dana Sakr, Marketing Manager"
        placeholder="blurred"
      />
    ),
    name: "Dana Sakr",
    designation: "Marketing Manager",
    company: "Step Conference",
    color: "#3b64ed",
    lightColor: "#CEFCED",
    lightestColor: "#D9E2FF",
    url: "/case-study/step-conference/",
    stats: `<span class='font-bold text-6xl'>50%</span><br /> <br />Growth in the new pipeline was achieved from the WOW Awards compared to 2022.`,
  },
  {
    logo: (
      <StaticImage
        src="../../images/client-logos/46.png"
        height={20}
        alt="Khaleej-times"
        placeholder="blurred"
      />
    ),
    message: `"It was a new idea that we implemented at Khaleej Times. And so far, everyone is so satisfied. The feedback from the audience and speakers was really amazing. So we’re looking forward to having Premagic power our future events as well.”`,
    profile: (
      <StaticImage
        src="../../images/case-study/khaleej-times/mohammed.png"
        class="rounded-full"
        width={60}
        height={60}
        alt="Mohammed Hegazy, Senior Conference Producer"
        placeholder="blurred"
      />
    ),
    name: "Mohammed Hegazy",
    designation: "Senior Conference Producer",
    company: "Khaleej Times",
    color: "#E15D4B",
    lightColor: "#FFD5CF",
    lightestColor: "#e5052117",
    url: "/case-study/khaleejtimes/",
    stats: `<span class='font-bold text-6xl'>200+</span><br /> <br />Social media posts were created about SaaSBOOMi.`,
  },
  {
    logo: (
      <StaticImage
        src="../../images/client-logos/53.png"
        height={40}
        alt="EO St.Louis"
        placeholder="blurred"
      />
    ),
    message: `"Premagic uses AI-powered smart photo distribution to deliver event photos straight to your attendees’ inboxes. Every photo I was in from the Entreprenuers' Organization conference was emailed directly to me. It basically turns every guest into an event marketer and it’s a pretty brilliant way to boost sponsorship visibility. Definitely something to consider for your next event!”`,
    profile: (
      <StaticImage
        src="../../images/case-study/entrepreneurs/avatar.png"
        class="rounded-full"
        width={60}
        height={60}
        alt="Joey Goone, Board Member"
        placeholder="blurred"
      />
    ),
    name: "Joey Goone",
    designation: "Board Member",
    company: "EO St.Louis",
    color: "#005255",
    lightColor: "#FFD5CF",
    lightestColor: "#e8fffd",
    url: "/case-study/entrepreneurs-organization/",
    stats: `<span class='font-bold text-6xl'>200+</span><br /> <br />Social media posts were created about SaaSBOOMi.`,
  },
  // {
  //   logo: (
  //     <StaticImage
  //       src="../../images/client-logos/THN.png"
  //       height={40}
  //       alt="Khaleej-times"
  //     />
  //   ),
  //   message: `"Premagic has been a true game-changer for our B2B marketing and business operations. While facial recognition is often the first thing that comes to mind, it’s actually just the beginning. The platform offers SO MANY valuable features; some of our favourites include branded content, sponsorship integrations, advocacy posters, and LinkedIn integration.”`,
  //   profile: (
  //     <StaticImage
  //       src="../../images/profile-photos/lorraine.png"
  //       class="rounded-full"
  //       width={60}
  //       height={60}
  //       alt="Joy joone"
  //     />
  //   ),
  //   name: "Lorraine Fernandes",
  //   designation: "Marketing Manager ",
  //   company: "The Hospitality Network",
  //   color: "#1a3100",
  //   lightColor: "#FFD5CF",
  //   lightestColor: "#f4ffe8",
  //   url: "",
  //   stats: `<span class='font-bold text-6xl'>200+</span><br /> <br />Social media posts were created about SaaSBOOMi.`,
  // },
  // {
  //   logo: (
  //     <StaticImage
  //       src="../../images/client-logos/23.png"
  //       height={60}
  //       alt="Khaleej-times"
  //     />
  //   ),
  //   message: `"What stood out with Premagic was how effortlessly it blended into the MEES experience. It wasn't just about sponsor visibility — it was about creating meaningful touchpoints with attendees, and giving our partners something measurable to walk away with.”`,
  //   profile: (
  //     <StaticImage
  //       src="../../images/case-study/middle-east-event/avatar2.png"
  //       class="rounded-full"
  //       width={60}
  //       height={60}
  //       alt="Joy joone"
  //     />
  //   ),
  //   name: "Amar Daginawala",
  //   designation: "Exhibition Director",
  //   company: "Informa Middle East",
  //   color: "#6e1b00",
  //   lightColor: "#FFD5CF",
  //   lightestColor: "#ffd1c1",
  //   url: "",
  //   stats: `<span class='font-bold text-6xl'>200+</span><br /> <br />Social media posts were created about SaaSBOOMi.`,
  // },
]

function TestimonialsCard(props) {
  const { data } = props

  return (
    <div className="flex flex-wrap mx-5 outline-none">
      <div
        className="px-7 md:px-7 w-full md:w-2/3 rounded-tl-2xl rounded-tr-2xl md:rounded-tr-none md:rounded-bl-2xl"
        style={{ backgroundColor: data.lightestColor }}
      >
        <div className="p-8 md:px-16 w-full h-full text-center rounded-2xl flex flex-col">
          <div className="-mt-10 ml-5 md:ml-24 scale-150">
            <QuoteIconWithColor color={data.color} />
          </div>
          <div className="my-5 h-16 flex items-center justify-center">
            {data?.logo}
          </div>
          <p
            className={`py-8 -mx-10 md:mx-0 overflow-hidden text-lg leading-relaxed md:mb-10 md:h-48`}
          >
            {data?.message}{" "}
          </p>
          <div className="flex justify-center">
            <div className="bg-white w-fit -mx-5 md:mx-0 p-5 rounded-xl flex mt-auto shadow-lg">
              <div className="rounded-full mr-5">{data.profile}</div>
              <div>
                <h4 className="text-sm font-extrabold text-black text-left">
                  {data?.name}
                </h4>
                <p className="text-sm text-left">{data?.designation || ""}</p>
                <p className="text-sm text-left">{data?.company || ""}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="w-full md:w-1/3 p-10 text-center md:text-left rounded-br-2xl rounded-bl-2xl md:rounded-bl-none md:rounded-tr-2xl"
        style={{ backgroundColor: data.lightColor }}
      >
        <div
          dangerouslySetInnerHTML={{ __html: data.stats }}
          className="text-xl font-semibold"
          style={{ color: data.color }}
        ></div>
        <Link
          to={data.url}
          className={`${btnSmall} ${btnPrimary} text-xs relative w-max mt-5`}
        >
          <File className="mr-2" />
          <span>Read Full Case Study</span>
        </Link>
      </div>
    </div>
  )
}

type Props = {
  hasHeading: boolean
}

export function Feebacks(props) {
  const { hasHeading } = props
  const { width } = useWindowDimensions()
  const isMobileUp = width >= 1080
  const containerWidth = isMobileUp ? "1080px" : "100%"

  const flickityOptions = {
    // autoPlay: 2000,
    wrapAround: true,
    // selectedAttraction: 0.01,
    // friction: 0.2,
    // cellAlign: 'center',
    // contain: true,
    // pageDots: true,
    // prevNextButtons: true,
    // pauseAutoPlayOnHover: false
  }

  return (
    <section>
      <div style={{ width: containerWidth }} className="mx-auto mb-16">
        {hasHeading && (
          <h2 className="text-black text-3xl md:text-5xl font-bold text-center leading-tight md:leading-tight relative z-20 py-20">
            Hear it from our Customers
          </h2>
        )}
        <Flickity
          flickityRef={c => (target = c)}
          className="carousel outline-none" // default ''
          // elementType="div"
          options={flickityOptions} // takes flickity options {}
          // disableImagesLoaded={false} // default false
          reloadOnUpdate // default false
          // static // default false
        >
          {TESTIMONIALS.map(item => (
            <TestimonialsCard data={item} />
          ))}
        </Flickity>
        {!hasHeading && (
          <div className="flex items-center justify-center mx-auto mt-10 ">
            <button
              className="rotate-180 border rounded-full border-purple-200 p-5 mx-3 group hover:bg-purple-300 transition duration-200 ease-in-out"
              onClick={() => target.previous()}
            >
              <BlackArrowRight className="transition duration-200 ease-in-out group-active:translate-x-1" />
            </button>
            <button
              className="border rounded-full border-purple-200 p-5 mx-3 group hover:bg-purple-300 transition duration-200 ease-in-out"
              onClick={() => target.next()}
            >
              <BlackArrowRight className="transition duration-200 ease-in-out group-active:translate-x-1" />
            </button>
          </div>
        )}
      </div>
    </section>
  )
}

export default Feebacks
